import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonRemoveAlt1Icon(props: IconProps) {
    return <Icon {...props} iconKey={"person_remove_alt_1"}/>
}
